<ng-template #contentHeaderTemplate></ng-template>

<div class="card h-100">
  <div class="card-body p-0">
    <div class="row ps-3 pe-2 pt-2">

      <div class="col-4">
        <app-authenticated-time-tracking-overview-month-picker
          [yearControl]="timeframeForm.controls.year"
          [monthControl]="view === 'month' ? timeframeForm.controls.month : undefined"
        ></app-authenticated-time-tracking-overview-month-picker>
      </div>

      <div class="btn-group col-2 offset-6 align-items-end">
        <button
          class="btn"
          [class.btn-primary]="view === 'month'"
          [class.btn-secondary]="view !== 'month'"
          (click)="setView('month')"
        >{{ 'authenticated.time_tracking.overview.index.views.month' | translate }}</button>

        <button
          class="btn"
          [class.btn-primary]="view === 'year'"
          [class.btn-secondary]="view !== 'year'"
          (click)="setView('year')"
        >{{ 'authenticated.time_tracking.overview.index.views.year' | translate }}</button>
      </div>
    </div>

    @if (globalFilter) {
      <div class="table-container">
        <app-table
          [id]="tableId"
          [showEditLink]="false"
          [showBorder]="false"
          [globalFilter]="globalFilter"
          [reloadEmitter]="reloadTable$"
          [isSubtable]="false"
          [functionList]="tableFunctionList"
        ></app-table>
      </div>
    }
  </div>
</div>
